import React from 'react'

const UserDashboard = () => {
    return (
        <div className='container text-center'>
            <h1>This is User Dashboard </h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores quo sed numquam inventore odio dignissimos officiis, vitae magni expedita, ducimus ullam amet vel nostrum ea blanditiis, incidunt quos natus! Blanditiis.</p>
        </div>
    )
}

export default UserDashboard